export enum RoleEnum {
  MODERATOR = 'moderator',
  ACCOUNTANT = 'accountant',
  MEMBERSHIP_OFFICE = 'membership_office',
  COMMUNITY_OFFICE = 'community_office',
  COMMUNITY_RELIGIOUS = 'community_religious',
  COMMUNITY_RESPONSIBLE = 'community_responsible',
  EDUCATION_OFFICE = 'education_office',
  EDUCATION_OFFICE_ASSISTANT = 'education_office_assistant',
  SCHOOL_OFFICE = 'school_office',
  INSPECTOR = 'inspector',
  TEACHER = 'teacher'
}
